import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { ConfigLoaderService } from 'src/app/Shared/Services/Config/config-loader.service';
import { ContactusService } from "src/app/Shared/Services/Contactus/contactus-service";
import { Contactus, UseCase, ClientIndustry, ClientMarket, FileDownloadpath } from "src/app/Shared/Model/contactus/contactus-model";
import { OfferingService } from 'src/app/Shared/Services/Offerings/offering.service'
import { saveAs } from 'file-saver';
import { Offering } from '../../Model/offerings/offering.model';
import { isEmpty } from 'rxjs/operators';
declare var $: any;
import { ErrorModel } from '../../Model/error/error-model';
import { ErrorServiceService } from '../../Services/Error/error-service.service';
import { HttpEventType, HttpResponse, HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  selectedoffering!: string;
  content: any;

  modalHeader!: string;
  modaldescription!: string;
  modalContent!: string;

  standardModuleHeader!: string;
  relatedLinksheader!: string;
  deliverables!: string;

  arrStandartModuleContents!: any[];
  arrrelatedLinksModuleContent!: any[];

  prereqDocketUrl!: string;
  prereqDocketname!: string;

  relDeckUrl!: any;
  relDeckName!: any;


  delDeckUrl!: string;
  delDeckName!: string;

  demoLink!: string;
  outputLink!: string;

  delOfflineName!: string;
  delOfflineurl!: string;

  modalDocketHeader!: string;
  modalDocketSubHeading!: string;

  contactmodel: Contactus = new Contactus();
  usecaselist!: UseCase[];
  clientmarketlist!: ClientMarket[];
  clientindustrylist!: ClientIndustry[];
  filepath!: FileDownloadpath;
  loading: boolean = true;
  @ViewChild('contactusform') form!: any;
  @ViewChild('closeModal') closeModal!: ElementRef
  showalertMsg: boolean = false;
  alertMsg!: string;
  alertmsgClass!: string;
  buttondisable: boolean = false;
  url: string = "";
  errModal!: ErrorModel;

  offering!: Offering[];
  shownote: boolean = false;
  showofferingDeck: boolean = true;
  showOutputDeck: boolean = true;
  offeringDeckText: string = 'Offerings Deck';
  filedownload = { status: '', progressPercent: '' };
  showFileDownloadInfo:boolean=false;

  showbuttonProceed:boolean=true;
  showAfterProceed:boolean=false;
 


  @ViewChild ('frame') public formModal: any;
  @ViewChild ('scrollframe') public scrollModal: any;
 

  successMessage: string = "Thank you for downloading the Pre-requisite docket. Kindly contact the ASD Team if any assistance is required."
  errorMessage: string = "Error in  downloading the Pre-requisite docket. Kindly contact the ASD Team .";
  filedownloadMessage:string="Docket Download is InProgress."
  filedownloadCompleteMessage:string ="Docket Download Completed"


  constructor(
    private router: Router,
    public modalRef: MDBModalRef,
    private modalService: MDBModalService,
    private contactService: ContactusService,
    private _configLoaderService: ConfigLoaderService,
    private _offeringService: OfferingService,
    private _errorService: ErrorServiceService) {
    this.filepath = new FileDownloadpath();
    this.errModal = new ErrorModel();
  }



  

  ngOnInit(): void {

    if (ConfigLoaderService.settings.env.name == "DEVELOPMENT") {
      this.contactmodel.UserId = ConfigLoaderService.settings.DevValues.userName;
    }
    else {
      this.contactmodel.UserId = ConfigLoaderService.settings.AppSettings.userId;
    }
    this.errModal.UserId = this.contactmodel.UserId;
    this.errModal.ComponentName = "ModalComponent";
    this.standardModuleHeader = "Standard Module Coverage";
    this.relatedLinksheader = "Related Links";
    this.deliverables = "Deliverables";

    this.modalDocketHeader = "DOWNLOAD ASD –" + this.selectedoffering + " PRE-REQUISITE DOCKET";
    this.modalDocketSubHeading = "Kindly provide us with the following information to help us serve you better. Please click on Download after filling in the client details.";

    this.errModal.MethodName = "ngInit";
    this.errModal.ErrorMessage = "Error getting offering Details";
   

    this._offeringService.getOfferingDetailsOnAppType1(this.selectedoffering, this.contactmodel.UserId)
      .subscribe((res: any) => {

        if ((this.isEmpty(res[0])) || res[0] == undefined) {
          this.modalRef.hide();
          this.closeModal.nativeElement.click();
          this._errorService.handleError('', this.errModal)
          this.router.navigate(["/error"]);

        }
        else {

          this.modalHeader = res[0]["HEADER"];
          this.modaldescription = res[0]["HEADER_DESCRIPTION"];
          this.arrStandartModuleContents = res[0]["STANDARD_MODULE_COVERAGE"].split(',');
       
          this.relDeckUrl = res[0]["OFFERING_DECK_URL"];
          this.demoLink = res[0]["DEMO_LINK"];
          this.prereqDocketname = res[0]["PREREQ_DOCKET_NAME"];
          this.prereqDocketUrl = res[0]["PREREQ_DOCKET_URL"];
          this.delDeckName = res[0]["SAMPLE_DECK_NAME"]
          this.delDeckUrl = res[0]["SAMPLE_DECK_URL"];
          this.delOfflineName = res[0]["SAMPLE_OFFLINE_NAME"];
          this.delOfflineurl = res[0]["SAMPLE_OFFLINE_URL"];
          this.outputLink = res[0]["OUTPUT_LINK"];
          this.loading = false;

          if (this.selectedoffering == 'upstream' || this.selectedoffering == 'utilities' || this.selectedoffering == 'downstream') {
            this.shownote = true;
          }
          if (this.selectedoffering == 'srm') {
            this.showofferingDeck = false;
            this.showOutputDeck = false;
          }
          if (this.selectedoffering == 'apo') {
            this.showOutputDeck = false;
            this.offeringDeckText = 'Sample Output Deck (Prepared by the client team)';
          }

        }

      },
        (error) => {
          this._errorService.handleError(error, this.errModal)

        });

    this.getUsecaseList();
    this.getClientMarketList();
    this.getClientIndustryList();


  }


  onNavigate1(linkname: string) {
   

    if (linkname == "demoLink") {
      this.url = this.demoLink;
    }
    else if(linkname == "offering"){
      this.url=this.relDeckUrl;
    }
    else {
      this.url = this.outputLink;
    }   
  }
  getUsecaseList() {
    this.errModal.MethodName = "GetUseCaseList";
    this.errModal.ErrorMessage = "Error getting UseCaseList";
    this.contactService
      .getUsecaseList(
        this.contactmodel.UserId
      )
      .subscribe(
        (data: any) => {
          if (data === undefined || data.length == 0) {
            this._errorService.handleError('', this.errModal)
          }
          else {
            this.usecaselist = data;
          }
        },
        (error) => {
          this._errorService.handleError(error, this.errModal)

        }
      );
  }

  getClientMarketList() {
    this.errModal.MethodName = "GetClientMarketList";
    this.errModal.ErrorMessage = "Error getting ClientMarketList";

    this.contactService
      .getClientMarketList(
        this.contactmodel.UserId
      )
      .subscribe(
        (data): any => {
          if (data === undefined || data.length == 0) {
            this._errorService.handleError('', this.errModal)
          }
          else {
            this.clientmarketlist = data;
          }
        },
        (error) => {
          this._errorService.handleError(error, this.errModal)
        }
      );
  }


  getClientIndustryList() {
    this.errModal.MethodName = "GetClientIndustryList";
    this.errModal.ErrorMessage = "Error getting ClientIndustryList";

    this.contactService
      .getClientIndustryList(
        this.contactmodel.UserId
      )
      .subscribe(
        (data: any) => {
          if (data === undefined || data.length == 0) {
            this._errorService.handleError('', this.errModal)
          }
          else {
            this.clientindustrylist = data;
          }
        },
        (error) => {
          this._errorService.handleError(error, this.errModal)
        }
      );
  }


  onSubmit() {
    this.showFileDownloadInfo=true;
    this.errModal.MethodName = "Submit";
    this.errModal.ErrorMessage = "Error on Submitting Contact";

    this.contactmodel.AppType = this.selectedoffering.toUpperCase();

    this.contactService
      .submitDetails
      (
        this.contactmodel
      )
      .subscribe(
        (data: any) => {
          this.loading = true;        
        
          $("#filedownloadsuccess").toast("show");
          this.alertmsgClass = 'alert alert-info';
          this.alertMsg = this.filedownloadMessage;
          this.showalertMsg = true;
         
          this.buttondisable = true;
          this.filepath.Filepath = data.body[0].filepath;
          this.filepath.Filename = data.body[0].filename;
          this.downloadFile('');

        },
        (error) => {
          this._errorService.handleError(error, this.errModal)
        }
      );

  }


  downloadFile(linkName: string) {
    this.loading = true;
    this.showFileDownloadInfo=true;

    if (linkName === "OfferingDeck") {
      this.filepath.Filepath = this.relDeckUrl,
        this.filepath.Filename = this.relDeckName
    }
    else if (linkName === "OutputDeck") {
      this.filepath.Filepath = this.delDeckUrl,
        this.filepath.Filename = this.delDeckName
    }
    else if (linkName === 'offlineReport') {

      this.filepath.Filepath = this.delOfflineurl,
        this.filepath.Filename = this.delOfflineName

    }
    else {
      this.filepath.Filepath = this.prereqDocketUrl,
        this.filepath.Filename = this.prereqDocketname
    }

    this.contactService.getFile
      (
        this.filepath
      )
      .subscribe(
        (data) => {
          var message = this.getStatusMessage(data, linkName);
          if (message.toLowerCase() == "done") {
            this.filedownload.progressPercent = "100";
            this.loading = false;
            this.showFileDownloadInfo=false;
            $("#success").toast("show");
            this.alertmsgClass = 'alert alert-success';
            this.alertMsg = this.successMessage;
            this.showalertMsg = true;


            if (linkName == '') {
              this.formreset();
              this.buttondisable = false;
       
            }
          }
         
        },
        (err: any) => {
          this.errModal.ErrorMessage = "Erroron saving file";
          $("#error").toast("show");
          this.showFileDownloadInfo=false;
          this.loading = false;
          this.alertmsgClass = 'alert alert-danger';
          this.alertMsg = this.errorMessage;
          this.showalertMsg = true;
          if (linkName == '') {
            this.formreset();
            this.buttondisable = false;
          }
          this._errorService.handleError(err, this.errModal)
        }
      );
  }

  getStatusMessage(event: any, linkName: string) {
    let status;

    switch (event.type) {
     
      case HttpEventType.DownloadProgress:
        
       
        status = Math.round(100 * event.loaded / event.total);
        this.filedownload.status = "InProgress"
        this.filedownload.progressPercent = status.toString();
        $("#filedownloadmodalsuccess").toast("show");
        this.alertmsgClass = 'alert alert-info';
        if (linkName == '') {
          this.alertMsg = this.filedownloadMessage
        }
        else
        {
          this.alertMsg = "Report Download is InProgress";
        }
       
        this.showalertMsg = true;

        return 'Files are ' + status + '% downloaded';

      case HttpEventType.Response:
        this.generateDownload(event.body!, linkName)      
        return 'Done';

      default:
        return 'Something went wrong'
    }
  }

  generateDownload(data: Blob, linkName: string) {
    saveAs(data, this.filepath.Filename); // from file-saver library 
  }

 

  OpenDisclaimerpopup(){
    this.formModal.show();

  }

  openScrollDocket(){
    this.scrollModal.show();
    this.formModal.hide();
  }






  closeAlert() {
    this.showalertMsg = false;
  }

  formreset() {
    this.form.resetForm();
    this.form.controls.clientmarket.setValue('');
    this.form.controls.clientindustry.setValue('');
    this.form.controls.usecase.setValue('');
  }

  isEmpty(obj: any) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }






}
